import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import * as Clipboard from 'expo-clipboard';

import styles from '../../style/scanpack';
import globalStyles from '../../style/global';

const OrderNumberHeader = ({
  orderIncrementId,
  onOrderPress,
  marginRight = 34,
  marginLeft = 34
}) => {
  const copyOrderNumberToClipboard = async () => {
    await Clipboard.setStringAsync(`${orderIncrementId}`);
  };

  return (
    <View dataSet={{componentName: 'orderDetailLink'}}>
      <TouchableOpacity
        testID="orderDetail"
        onPress={onOrderPress}
        delayLongPress={1000}
        style={{marginRight, marginLeft}}>
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={[styles.nowScanningTextView, globalStyles.nextItemOrder]}>
          Order {orderIncrementId || 'N/A'}
          <TouchableOpacity onPress={copyOrderNumberToClipboard}>
            <i
              className="icon-docs"
              style={{
                color: '#8e8b8b',
                fontSize: '20px',
                marginLeft: '10px'
              }}></i>
          </TouchableOpacity>
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default OrderNumberHeader;
